// extracted by mini-css-extract-plugin
module.exports = {"sticky":"WorkspacesMyReports_sticky__3xfUf","workspacesMyReports":"WorkspacesMyReports_workspacesMyReports__FK0mv"};